import React, {useEffect, useState} from "react";
import {Localizer} from "../../infrastructure/localization/localizer";
import {Tab, Tabs} from "../../core/components/Tabs/Tabs";
import {removeWhiteSpace} from "../../core/helpers/stringHelper";
import {useHistory, useRouteMatch} from "react-router-dom";
import {dashboardQueryParams} from "../../infrastructure/route/queryParams";
import {DashboardOverview} from "./dashboardOverview";
import {DashboardFilters} from "./dashboardFilters";
import classNames from "classnames";
import useScreenResolution from "../../core/hooks/useScreenResolution";
import useDashboardPage from "./useDashboardPage";
import {DashboardList} from "./dashboardList/dashboardList";
import useUser from "../../core/hooks/useUser";
import {RolleTitelEnum} from "../../infrastructure/enums/rolleTitelEnum";
import {DashboardListUko} from "./dashboardList/dashboardListUko";

export const Dashboard = () => {
    const history = useHistory();
    const {isMobile} = useScreenResolution();
    const {currentUser} = useUser();
    //Tab-Id from route
    const {activeTab} = useRouteMatch<dashboardQueryParams>().params;
    const [activeTabId, setActiveTabId] = useState(activeTab);
    const overviewTabId = removeWhiteSpace(Localizer.dashboard_overview());
    const listViewTabId = removeWhiteSpace(Localizer.dashboard_listView());
    const {filter, setFilter, initialFetchRef} = useDashboardPage();

    useEffect(() => {
        setActiveTabId(activeTab);
    }, [activeTab]);

    const tabs: Tab[] = [
        {
            id: overviewTabId,
            title: Localizer.global_overview(),
            defaultActive: activeTabId === overviewTabId,
            content:
                <div className={classNames("card-body", isMobile ? "padding-0" : "padding-top-0")}>
                    <DashboardOverview/>
                </div>
        }, {
            id: listViewTabId,
            title: Localizer.global_listview(),
            defaultActive: activeTabId === listViewTabId,
            content: currentUser.hasRolleTitel(RolleTitelEnum.Uko)
                ? <DashboardListUko/>
                : <DashboardList includeOrlov={filter.includeOrlov}/>
        }
    ];

    const handleTabClick = (id: string) => {
        setActiveTabId(id);
        history.push(`/dashboard/activetab/${id}`);
    };

    return (
        <>
            <div className={"card card-no-margin padding-top-m border-bottom-0 shadow-none"}>
                <div className={"card-header border-bottom-0 card-no-margin flex-wrap flex-space"}>
                    <div className={"align-self-start flex-container-row align-items-center"}>
                        <h3 className={"margin-right-s"}>{Localizer.global_dashboard()}</h3>
                    </div>
                </div>
            </div>
            <Tabs
                flexEnd
                additionalClasses={"bg-white"}
                tabs={tabs}
                navTabRightSideContent={<DashboardFilters filter={filter}
                                                          setFilter={setFilter}
                                                          initialFetchRef={initialFetchRef}/>}
                setActiveCallback={id => handleTabClick(id)}
            />
        </>

    );
}
